import { render, staticRenderFns } from "./OrdersSummaryByProduct.vue?vue&type=template&id=4e823fd6&scoped=true"
import script from "./OrdersSummaryByProduct.vue?vue&type=script&lang=js"
export * from "./OrdersSummaryByProduct.vue?vue&type=script&lang=js"
import style0 from "./OrdersSummaryByProduct.vue?vue&type=style&index=0&id=4e823fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e823fd6",
  null
  
)

export default component.exports